import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=45786e7c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=45786e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45786e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45786e7c')) {
      api.createRecord('45786e7c', component.options)
    } else {
      api.reload('45786e7c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=45786e7c&scoped=true&", function () {
      api.rerender('45786e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fdWbAyQ59AU3/JS/comp/PopupDialog.vue"
export default component.exports